import { apiGet, apiPost } from "./helpers/api";

export const checkEventSource = (dispatch, bannerId) => {
  return apiGet(`/api/v1/event_sources?banner_id=${bannerId}`)
    .then((response) => ({
      exists: response.body.data && response.body.data.length > 0,
      data: response.body.data
    }))
    .catch(() => {
      // If error, assume doesn't exist
      return { exists: false, data: null };
    });
};

export const createEventSource = (dispatch, bannerId, metadata = {}) => {
  return apiPost("/api/v1/event_sources")
    .send({
      banner_id: bannerId,
      metadata: metadata
    })
    .then((response) => ({
      data: response.body.data,
      status: response.status,
      isNew: response.status === 201
    }))
    .catch((error) => {
      throw error;
    });
};
